export class PublicBrandingImage {
    isLogo: boolean;
    base64File: string;

    constructor(isLogo: boolean, base64File: string) {
        this.isLogo = isLogo;
        this.base64File = base64File;
    }

    getLogoData() {
        return this.isLogo ? 'data:image/jpeg;base64,' + this.base64File : '';
    }

    getImageData() {
        return !this.isLogo ? 'data:image/jpeg;base64,' + this.base64File : '';
    }
}
